import { Component, Input, OnInit, OnChanges, SimpleChanges, AfterViewInit, ViewChild, OnDestroy } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';

import { Subscription } from 'rxjs';

import { MenuItem } from 'primeng/api';

import { ThemeComponent } from './theme.component';

import { MenuService } from '../services/menu.service';

@Component({
    selector: '[theme-menu]',
    templateUrl: './theme.menu.component.html',
    standalone: false
})
export class ThemeMenuComponent implements OnInit, OnDestroy {

    @Input() reset: boolean;

    model: MenuItem[] = [];
    loading: boolean = true;

    private menuSubscription: Subscription;

    constructor(public app: ThemeComponent, private menuService: MenuService) {
    }

    ngOnInit(): void {
        this.menuSubscription = this.menuService.FullMenu.subscribe(menu => {
            this.model = menu;
            this.loading = false;
        });
    }

    ngOnDestroy(): void {
        if (this.menuSubscription)
            this.menuSubscription.unsubscribe();
    }
}

@Component({
    /* eslint-disable @angular-eslint/component-selector */
    selector: '[theme-submenu]',
    /* eslint-enable @angular-eslint/component-selector */
    templateUrl: './theme.submenu.component.html',
    animations: [
        trigger('children', [
            state('hiddenAnimated', style({
                height: '0px'
            })),
            state('visibleAnimated', style({
                height: '*'
            })),
            state('visible', style({
                height: '*',
                'z-index': 100
            })),
            state('hidden', style({
                height: '0px',
                'z-index': '*'
            })),
            transition('visibleAnimated => hiddenAnimated', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')),
            transition('hiddenAnimated => visibleAnimated', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
        ])
    ],
    standalone: false
})
export class ThemeSubMenuComponent implements OnInit, OnChanges {
    ngOnInit(): void {
        if (this.root) {
            const index = (<MenuItem[]>this.item).findIndex(i => i.items && i.items.length > 0);

            this.activeIndex = index === -1 ? null : index;
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['item'] || changes['root']) {
            if (this.root) {
                const index = (<MenuItem[]>this.item).findIndex(i => i.items && i.items.length > 0);

                this.activeIndex = index === -1 ? null : index;
            }
        }
    }

    @Input() item: MenuItem | MenuItem[];

    @Input() root: boolean;

    @Input() visible: boolean;

    get items(): MenuItem[] {
        return this.root ? <MenuItem[]> this.item : (<MenuItem> this.item).items;
    }

    _parentActive: boolean;

    _reset: boolean;

    activeIndex: number;

    constructor(public app: ThemeComponent, public appMenu: ThemeMenuComponent) { }

    itemClick(event: Event, item: MenuItem, index: number): void {
        // avoid processing disabled items
        if (item.disabled) {
            event.preventDefault();
            return;
        }

        // activate current item and deactivate active sibling if any
        this.activeIndex = (this.activeIndex === index) ? null : index;

        // execute command
        if (item.command) {
            item.command({ originalEvent: event, item });
        }

        // prevent hash change
        if (item.items || (!item.url && !item.routerLink)) {
            event.preventDefault();
        }

        // hide menu
        if (!item.items) {
        }
    }

    isActive(index: number): boolean {
        return this.activeIndex === index;
    }

    @Input() get reset(): boolean {
        return this._reset;
    }

    set reset(val: boolean) {
        this._reset = val;

        if (this._reset) {
            this.activeIndex = null;
        }
    }

    @Input() get parentActive(): boolean {
        return this._parentActive;
    }

    set parentActive(val: boolean) {
        this._parentActive = val;

        if (!this._parentActive) {
            this.activeIndex = null;
        }
    }
}
